import axios from "axios";

// export const productionAddr = "https://publisher.cryptooants.com/";
export const productionAddr = 'https://uat-publisher.cryptooants.com/';

/* ===============================
   CANCEL TOKEN
================================= */

let cancelTokens = [];

function addCancelToken() {
  const source = axios.CancelToken.source();
  cancelTokens.push(source);
  return source.token;
}

function removeCancelToken(token) {
  cancelTokens = cancelTokens.filter((source) => source.token !== token);
}

export function cancelAllRequests() {
  cancelTokens.forEach((source) => source.cancel("Request cancelled"));
  cancelTokens = [];
}

/* ===============================
   MAIN SERVER INSTANCE
================================= */

export const serverAddr = axios.create({
  baseURL: productionAddr,
  timeout: 300000,
  withCredentials: true
});

/* ===============================
   REQUEST INTERCEPTOR
================================= */

serverAddr.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = "Bearer " + token;
  }

  config.headers["Content-Type"] = "application/json";

  config.cancelToken = addCancelToken();

  return config;
});

/* ===============================
   RESPONSE INTERCEPTOR
================================= */

serverAddr.interceptors.response.use(
  (response) => {

    removeCancelToken(response.config.cancelToken);

    const data = response.data;

    setToken(data);

    if (!data.status && data.validation) {
      alert(data.validation);
    }

    return data;
  },

  (error) => {

    if (axios.isCancel(error)) {
      console.log("Request cancelled");
      return;
    }

    removeCancelToken(error.config?.cancelToken);

    if (error.response) {

      if (error.response.status === 401) {
        logoutUser();
      }

      return Promise.reject(error.response.data);
    }

    return Promise.reject(error);
  }
);

/* ===============================
   FILE UPLOAD API
================================= */

export const uploadServer = axios.create({
  baseURL: productionAddr,
  timeout: 300000
});

uploadServer.interceptors.request.use((config) => {

  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = "Bearer " + token;
  }

  config.headers["Content-Type"] = "multipart/form-data";

  return config;
});


/* ===============================
   TOKEN MANAGEMENT
================================= */

function setToken(data) {

  if (data?.token_data?.access_token) {
    localStorage.setItem("token", data.token_data.access_token);
  }

  if (data?.token_data?.refresh_token) {
    localStorage.setItem("refresh_token", data.token_data.refresh_token);
  }

  if (data?.expire_in) {
    localStorage.setItem("expire_in", data.expire_in);
  }
}

/* ===============================
   LOGOUT HANDLER
================================= */

function logoutUser() {

  cancelAllRequests();

  localStorage.clear();

  window.location.href = "/login";
}